import {englishType} from 'types'

export const lesson22: englishType[] = [
  {
    id: 1,
    word: "accommodate",
    meaning: ["수용하다", "공간을 제공하다"]
  }, {
    id: 2,
    word: "admire",
    meaning: ["칭찬하다", "존경하다", "감탄하다"]
  }, {
    id: 3,
    word: "adorn",
    meaning: ["꾸미다", "장식하다"]
  }, {
    id: 4,
    word: "apostle",
    meaning: ["사도", "주창자"]
  }, {
    id: 5,
    word: "asleep",
    meaning: ["잠든", "잠이 든", "자고 있는"]
  }, {
    id: 6,
    word: "assume",
    meaning: ["추정하다", "맡다", "가장하다"]
  }, {
    id: 7,
    word: "atmosphere",
    meaning: ["대기", "공기", "분위기"]
  }, {
    id: 8,
    word: "attack",
    meaning: ["폭행", "폭행하다", "공격", "공격하다"]
  }, {
    id: 9,
    word: "attract",
    meaning: ["마음을 끌다", "끌어들이다"]
  }, {
    id: 10,
    word: "beast",
    meaning: ["짐승", "야수"]
  }, {
    id: 11,
    word: "betrayal",
    meaning: ["배신", "배반"]
  }, {
    id: 12,
    word: "blindfold",
    meaning: ["눈가리개", "안대"]
  }, {
    id: 13,
    word: "botanical",
    meaning: ["식물의"]
  }, {
    id: 14,
    word: "celebrate",
    meaning: ["기념하다", "축하하다", "찬양하다"]
  }, {
    id: 15,
    word: "code",
    meaning: ["암호", "코드", "부호"]
  }, {
    id: 16,
    word: "coexist",
    meaning: ["공존하다"]
  }, {
    id: 17,
    word: "colleague",
    meaning: ["동료"]
  }, {
    id: 18,
    word: "combination",
    meaning: ["조합", "부호", "결합"]
  }, {
    id: 19,
    word: "commission",
    meaning: ["의뢰하다", "위원회", "의뢰"]
  }, {
    id: 20,
    word: "considerate",
    meaning: ["사려 깊은", "배려심 있는", "배려 깊은"]
  }, {
    id: 21,
    word: "contemporary",
    meaning: ["동시대의", "동년배", "현대의", "같은 시대의"]
  }, {
    id: 22,
    word: "convent",
    meaning: ["수녀원"]
  }, {
    id: 23,
    word: "criticism",
    meaning: ["비판", "비평", "비난"]
  }, {
    id: 24,
    word: "customs service",
    meaning: ["관세청"]
  }, {
    id: 25,
    word: "destiny",
    meaning: ["운명"]
  }, {
    id: 26,
    word: "disciple",
    meaning: ["제자"]
  }, {
    id: 27,
    word: "dismay",
    meaning: ["실망", "경악", "크게 실망시키다"]
  }, {
    id: 28,
    word: "donate",
    meaning: ["기부하다", "기증하다", "기부금을 내다"]
  }, {
    id: 29,
    word: "easygoing",
    meaning: ["느긋한", "마음 편안한"]
  }, {
    id: 30,
    word: "era",
    meaning: ["시대"]
  }, {
    id: 31,
    word: "exhibition",
    meaning: ["전시회", "전시", "발휘", "표현"]
  }, {
    id: 32,
    word: "exotic",
    meaning: ["외국의", "이국적인"]
  }, {
    id: 33,
    word: "fascinated",
    meaning: ["매료된", "마음을 빼앗긴"]
  }, {
    id: 34,
    word: "favorably",
    meaning: ["호의적으로", "우호적으로"]
  }, {
    id: 35,
    word: "frustrated",
    meaning: ["실망한", "좌절한", "좌절감을 느끼는", "불만스러워 하는", "좌절당한"]
  }, {
    id: 36,
    word: "full moon",
    meaning: ["보름달", "만월"]
  }, {
    id: 37,
    word: "gigantic",
    meaning: ["거대한"]
  }, {
    id: 38,
    word: "gorgeous",
    meaning: ["아름다운", "화려한"]
  }, {
    id: 39,
    word: "gypsy",
    meaning: ["집시"]
  }, {
    id: 40,
    word: "harsh",
    meaning: ["가혹한", "혹독한"]
  }, {
    id: 41,
    word: "hothouse",
    meaning: ["온실"]
  }, {
    id: 42,
    word: "illustrated",
    meaning: ["삽화를 넣은"]
  }, {
    id: 43,
    word: "logical",
    meaning: ["논리적인"]
  }, {
    id: 44,
    word: "look forward to",
    meaning: ["~를 기대하다"]
  }, {
    id: 45,
    word: "magnify",
    meaning: ["확대하다", "확장하다", "과장하다"]
  }, {
    id: 46,
    word: "mainstream",
    meaning: ["주류", "대세", "정신적 장애아를 일반 학교에 편입시키다"]
  }, {
    id: 47,
    word: "make sense",
    meaning: ["이해되다", "말이되다", "의미가 통하다", "타당하다"]
  }, {
    id: 48,
    word: "markedly",
    meaning: ["현격히", "현저히", "현저하게", "두드러지게"]
  }, {
    id: 49,
    word: "marvelous",
    meaning: ["놀라운", "믿기 어려운", "신기한", "기묘한", "기적적인", "불가사의한"]
  }, {
    id: 50,
    word: "merchant",
    meaning: ["상인"]
  }, {
    id: 51,
    word: "method",
    meaning: ["방법"]
  }, {
    id: 52,
    word: "microscope",
    meaning: ["현미경"]
  }, {
    id: 53,
    word: "more than meets the eye",
    meaning: ["보이는 것 이상의 것", "눈에 보이는 이상의 것", "눈에 보이는 것 이상의 것", "숨겨진 것"]
  }, {
    id: 54,
    word: "motivate",
    meaning: ["동기를 부여하다"]
  }, {
    id: 55,
    word: "mural",
    meaning: ["벽화"]
  }, {
    id: 56,
    word: "naive",
    meaning: ["순진한", "순진해 빠진"]
  }, {
    id: 57,
    word: "observe",
    meaning: ["관찰하다"]
  }, {
    id: 58,
    word: "obstacle",
    meaning: ["장애", "장애물"]
  }, {
    id: 59,
    word: "overjoyed",
    meaning: ["매우 기뻐하는", "매우 기쁜"]
  }, {
    id: 60,
    word: "portray",
    meaning: ["그리다", "묘사하다", "나타내다", "연기하다"]
  }, {
    id: 61,
    word: "prediction",
    meaning: ["예측", "예언", "예견"]
  }, {
    id: 62,
    word: "pursue",
    meaning: ["추구하다", "계속하다", "뒤쫓다"]
  }, {
    id: 63,
    word: "recognized",
    meaning: ["인정된", "알려진", "인정 받는"]
  }, {
    id: 64,
    word: "representative",
    meaning: ["대표", "대표하는", "전형적인"]
  }, {
    id: 65,
    word: "request",
    meaning: ["요청", "요청하다", "요구", "요구하다"]
  }, {
    id: 66,
    word: "resemble",
    meaning: ["닮다", "비슷하다"]
  }, {
    id: 67,
    word: "restriction",
    meaning: ["제약", "제한", "구속"]
  }, {
    id: 68,
    word: "seemingly",
    meaning: ["외견상으로", "겉보기에", "보아하니"]
  }, {
    id: 69,
    word: "semester",
    meaning: ["학기"]
  }, {
    id: 70,
    word: "sniff",
    meaning: ["코를 훌쩍거리다", "코를 킁킁거리다", "냄새를 맡다"]
  }, {
    id: 71,
    word: "somewhat",
    meaning: ["어느 정도", "약간", "다소"]
  }, {
    id: 72,
    word: "starving",
    meaning: ["굶주린", "굶김"]
  }, {
    id: 73,
    word: "stick to",
    meaning: ["~를 유지하다", "~상태를 유지하다", "~를 지키다", "~를 굳게 지키다"]
  }, {
    id: 74,
    word: "stillness",
    meaning: ["고요", "정적"]
  }, {
    id: 75,
    word: "surrealism",
    meaning: ["초현실주의"]
  }, {
    id: 76,
    word: "unfamiliar",
    meaning: ["익숙치 않은", "낮선", "익숙치 않은"]
  }, {
    id: 77,
    word: "unremarkable",
    meaning: ["특별할 것 없는", "평범한"]
  }, {
    id: 78,
    word: "wealthy",
    meaning: ["부유한", "재산이 많은"]
  }, {
    id: 79,
    word: "well known",
    meaning: ["잘 알려진", "많이 알려진", "유명한"]
  }, {
    id: 80,
    word: "whopping",
    meaning: ["굉장히 큰", "엄청 큰"]
  }, {
    id: 81,
    word: "willingly",
    meaning: ["기꺼이"]
  },
]
